import {registerRoute} from '@/router'
import FeaturesToggles from '@/feature-toggles/FeaturesToggles.vue'
import {useContaCommand} from '@/commandbar/commandBar.service'

const FEATURE_TOGGLES = {componentName: 'FeatureToggles', component: FeaturesToggles, meta: {requiresOrg: true}}

registerRoute(FEATURE_TOGGLES)

const {registerNavigationCommand} = useContaCommand()

const icon = 'i-ph-bug'
const label = 'Feature toggle'
const hotkey = 'f'

registerNavigationCommand({
    route: FEATURE_TOGGLES,
    hotkey,
    icon,
    label
})
